module.exports = __webpack_public_path__ + "img/Outline.60daae7d.svg";